import React from 'react';
import { JumbotronTypes } from '../../../jumbotronTypes';

export const TextOverlay = ({ textOverlay }: JumbotronTypes.ICard) => {
  return (
    <>
      <div className="is-flex jumbotronSectionTitleDiv">
        <span className="Title"></span>
        <h3>
          <>{textOverlay?.title}</>
        </h3>
      </div>
      <p className="subtitle2">{textOverlay?.subTitle}</p>
    </>
  );
};
